var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8095 21.1904H33.0952C34.1472 21.1904 35 22.0432 35 23.0952V26.9047C35 27.9567 34.1472 28.8095 33.0952 28.8095H28.8095V33.0952C28.8095 34.1472 27.9567 35 26.9047 35H23.0952C22.0432 35 21.1904 34.1472 21.1904 33.0952V28.8095H16.9048C15.8528 28.8095 15 27.9567 15 26.9047V23.0952C15 22.0432 15.8528 21.1904 16.9048 21.1904H21.1904V16.9048C21.1904 15.8528 22.0432 15 23.0952 15H26.9047C27.9567 15 28.8095 15.8528 28.8095 16.9048V21.1904ZM26.9047 22.1428V16.9048H23.0952V22.1428C23.0952 22.6688 22.6688 23.0952 22.1428 23.0952H16.9048V26.9047H22.1428C22.6688 26.9047 23.0952 27.3311 23.0952 27.8571V33.0952H26.9047V27.8571C26.9047 27.3311 27.3311 26.9047 27.8571 26.9047H33.0952V23.0952H27.8571C27.3311 23.0952 26.9047 22.6688 26.9047 22.1428Z",
    fill: "#F4F9FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.167,
    y: 41.6665,
    width: 5.83333,
    height: 1.66667,
    rx: 0.833333,
    fill: "#A0CCEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.456f8f4759352962de386ca7b88663dd.svg";
export { ForwardRef as ReactComponent };